export default "__VITE_ASSET__Di4Yh6mh__"